import Description from './index.vue'

Description.install = Vue => {
    Vue.component(Description.name, Description)
}

export {
    Description
}



// WEBPACK FOOTER //
// ./src/components/descirption/index.js